import common from './common'

//初期表示時イベント
function inputRetention(obj) {
    //入力保持
    obj.items = common.getStore(obj, 'largeItems')
    //「中型」表示品目数を取得
    obj.mediumView = common.countMediumView(obj)
    // 「小型」表示品目数を取得
    obj.smallView = common.countSmallView(obj)
    const addressFormSelected = common.getStore(obj, 'addressFormSelected')
    const params = new URLSearchParams({
        yubin: addressFormSelected.YUBIN.replace('-', ''),
        jis5cd: addressFormSelected.JIS5CD,
        site_code: process.env.VUE_APP_SITE_CODE,
        item: common.constant.CODE_AC
    })
    //全メーカ、サイズ、取り外し料金取得
    let url = common.constant.GET_MAKER_SIZE_URL + params
    let func = function (response) {
        const data = response.data
        obj.masterData.makers = data.makers
        obj.masterData.sizes = data.sizes
        obj.masterData.removalFees = data.removal_fees
    }
    common.executeAxiosGet(url, func, obj)
}

//大型家電のあり、なし押下時
function isExist(obj, bool, item) {
    if (bool) {
        this.setUnit(obj, item, 1)

    } else {
        item.unit = 0

        //選択したメーカー、サイズを削除
        item.selectedMakerSizeList = []
        //サイズの選択肢を削除
        item.sizeLists = []

    }
}

//台数追加時
function setUnit(obj, item, num) {
    item.unit = num
    obj.getMaker(item)

    //selectedMakerSizeListとsizeListsのひな型を作成
    let sizeListsBeta = {}
    sizeListsBeta['sizeList'] = []
    item.sizeLists.push(sizeListsBeta)

    let selectedMakerSizeListBeta = {}
    selectedMakerSizeListBeta['selectedMaker'] = ''
    selectedMakerSizeListBeta['selectedSize'] = ''
    selectedMakerSizeListBeta['required_maker'] = false
    selectedMakerSizeListBeta['required_size'] = false

    if (item.code === common.constant.CODE_AC) {
        // removalWorkListsのひな型を作成
        item.removalWorkLists.push({
            'removalWorkList': []
        })

        selectedMakerSizeListBeta['selectedRemovalWork'] = ''
        selectedMakerSizeListBeta['requiredRemovalWork'] = false
    }
    item.selectedMakerSizeList.push(selectedMakerSizeListBeta)
}

//台数削除時
function deleteUnit(item, num) {
    //1台の時は削除しない
    if (item.unit == 1) { return }

    let delIdx = num - 1
    //選択したメーカー、サイズを削除
    item.selectedMakerSizeList.splice(delIdx, 1)
    //サイズの選択肢を削除
    item.sizeLists.splice(delIdx, 1)
    //台数を1台減算
    item.unit -= 1

    if (item.code === common.constant.CODE_AC) {
        item.removalWorkLists.splice(delIdx, 1)
    }
}

//メーカー取得
function getMaker(obj, item) {
    //品目でメーカーを絞り込み
    item.makerList = obj.masterData.makers.filter(maker => maker.ITEM === item.code)
}

//サイズ取得
function getSize(obj, item, n) {
    //メーカー変更時にサイズをクリアする。
    item.selectedMakerSizeList[n - 1].selectedSize = ''
    //品目、メーカーでサイズを絞り込み
    item.sizeLists[n - 1].sizeList = obj.masterData.sizes.filter(size => size.ITEM === item.code && size.MAKER === item.selectedMakerSizeList[n - 1].selectedMaker.CODE)

    if (item.code === common.constant.CODE_AC) {
        this.getRemovalWork(obj, item, n);
    }
}

// エアコンに取り外し作業取得
function getRemovalWork(obj, item, n) {
    item.selectedMakerSizeList[n - 1].selectedRemovalWork = ''
    const removalFee = obj.masterData.removalFees.filter(removal => removal.ITEM === item.code && removal.MAKER === item.selectedMakerSizeList[n - 1].selectedMaker.CODE)

    if (removalFee[0].REMOVAL_FEE) {
        item.removalWorkLists[n - 1].removalWorkList = [
            {
                name: '必要',
                value: '1',
            },
            {
                name: '不要',
                value: '0',
            }
        ]
    }
}

//次へ押下時
function submitLargeItems(obj) {
    //エラーフラグを初期化
    obj.setErrorFlg(false)
    obj.error = false

    obj.items.forEach(item => {
        item.selectedMakerSizeList.forEach(function (selectedMakerSize, index) {

            selectedMakerSize.required_maker = false
            selectedMakerSize.required_size = false

            if (selectedMakerSize.selectedMaker == '') {
                //メーカーの必須チェック
                obj.setErrorFlg(true)
                selectedMakerSize.required_maker = true
            } else if (item.sizeLists[index].sizeList.length > 0 && selectedMakerSize.selectedSize == '') {
                //サイズの必須チェック
                obj.setErrorFlg(true)
                selectedMakerSize.required_size = true
            }

            // エアコンの場合、下記のチェックを追加
            if (item.code === common.constant.CODE_AC) {
                selectedMakerSize.requiredRemovalWork = false
                if (item.removalWorkLists[index].removalWorkList.length > 0 && selectedMakerSize.selectedRemovalWork === '') {
                    obj.setErrorFlg(true)
                    selectedMakerSize.requiredRemovalWork = true
                }
            }

        }, item);
    });

    // 画面遷移先をセット
    let path = common.constant.SPECIFIC_DATETIME_PATH
    if (obj.mediumView) {
        path = common.constant.MEDIUM_ITEMS_PATH
    } else if (obj.smallView) {
        path = common.constant.SMALL_ITEMS_PATH
    }

    // 選択した大型品目数
    let count = 0
    obj.items.forEach(item => {
        item.selectedMakerSizeList.forEach((selected, index) => {
            if (selected.selectedMaker && item.sizeLists[index].sizeList.length > 0 && selected.selectedSize) {
                count++
            } else if (selected.selectedMaker && item.sizeLists[index].sizeList.length ===0) {
                count++
            }
        })
    })

    // 選択先が「回収日時」、かつ選択した大型品目数が0の場合
    if (!obj.errorFlg() && path === common.constant.SPECIFIC_DATETIME_PATH && count === 0) {
        obj.error = true
        obj.setErrorFlg(true)
    }

    //エラーフラグをストアにセット
    common.setStore(obj, 'errorFlg', obj.errorFlg())

    //大型家電の入力情報をストアに保存
    common.setStore(obj, 'largeItems', obj.items)

    //storeの日時選択情報クリア
    common.setStore(obj, 'specificDate', '')
    common.setStore(obj, 'specificTime', '')

    common.setRoute(obj, path)
}

export default {
    common,
    inputRetention,
    isExist,
    setUnit,
    deleteUnit,
    getMaker,
    getSize,
    getRemovalWork,
    submitLargeItems
}
